import type { Role } from '../api/types'

// transcoder nằm ngoài thang bậc (rank 0): không bao giờ đạt `min` nào của thang.
const rank: Record<Role, number> = { transcoder: 0, viewer: 1, operator: 2, admin: 3 }

/** Mirrors internal/auth Role.AtLeast on the server (transcoder luôn false). */
export function roleAtLeast(role: Role | undefined, min: Role): boolean {
  if (role === undefined || role === 'transcoder') return false
  return rank[role] >= rank[min]
}

export function isTranscoder(role: Role | undefined): boolean {
  return role === 'transcoder'
}

export interface Access {
  /** Thang bậc tối thiểu (viewer/operator/admin). */
  min: Role
  /** Mở tường minh cho role transcoder (mặc định đóng). */
  transcoder?: boolean
}

/** Mirrors auth.Gate: transcoder chỉ qua khi `transcoder` bật tường minh. */
export function canAccess(role: Role | undefined, access: Access): boolean {
  if (role === undefined) return false
  if (role === 'transcoder') return access.transcoder === true
  return roleAtLeast(role, access.min)
}
